





















import ProductItem from '../common/product_item.vue'
import { Component, Mixins, Inject, Provide } from 'vue-property-decorator'
import SearchCategory from '../common/search_category.vue'
import SearchLoadList from '../mixins/LoadList'
import Screen from '../common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { namespace } from 'vuex-class'
import { SearchRefresh } from '../searchAll/index.vue'
import { getSearchResult, RequestType } from '../../search-service'
const searchResModule = namespace('searchRes') //vuex

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    ProductItem,
    SearchCategory,
    Screen
  }
})
export default class SearchProduct extends Mixins(SearchLoadList) {
  @searchResModule.Mutation setProductNum!: (arg: number) => void
  @searchResModule.State location!: any
  @searchResModule.State categoryList!: any
  @searchResModule.State productCategorySelect!: any
  @searchResModule.Mutation setProductCategorySelect!: any

  @searchResModule.State districtList!: any
  @searchResModule.State productDistrictSelect!: any
  @searchResModule.Mutation setProductDistrictSelect!: any

  @searchResModule.State productDistanceSort!: boolean
  @searchResModule.State productSalesSort!: boolean
  @searchResModule.State productDefaultSort!: boolean
  @searchResModule.Mutation setProductDefaultSort!: (arg: any) => void //设置商品距离排序
  @searchResModule.Mutation setProductDistanceSort!: (arg: any) => void //设置商品距离排序
  @searchResModule.Mutation setProductSalesSort!: (arg: any) => void //设置商品销量排序
  @searchResModule.Mutation resetProduct!: () => void //重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200009')
  clickid_200009!: string

  @Provide()
  clickid_200005 = '200005'

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshProduct, () => {
        this.refresh()
      })
    }, 1000)
  }

  //距离排序是否展示
  get locationVis() {
    return this.location && this.location.lat && this.location.lng
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshProduct)
  }

  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  get classifyExposure() {
    return `${this.clickid_200009}`
  }

  changeProductDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '距离' } })
    if (this.loading) return
    this.setProductDistanceSort(!this.productDistanceSort)
    if (this.productDistanceSort) {
      this.setProductSalesSort(false)
      this.setProductDefaultSort(false)
    }
    this.refresh()
  }

  changeProductSalesSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '销量' } })
    if (this.loading) return
    this.setProductSalesSort(!this.productSalesSort)
    if (this.productSalesSort) {
      this.setProductDistanceSort(false)
      this.setProductDefaultSort(false)
    }
    this.refresh()
  }

  changeProductDefaultSort() {
    if (this.loading) return
    this.setProductDefaultSort(!this.productDefaultSort)
    if (this.productDefaultSort) {
      this.setProductDistanceSort(false)
      this.setProductSalesSort(false)
    }
    this.refresh()
  }

  changeProductCategory(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '分类' } })
    this.setProductCategorySelect(value)
    this.refresh()
  }

  changeProductDistrict(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200009, positionParam: { searchtype: '区域' } })
    this.setProductDistrictSelect(value)
    this.refresh()
  }

  async onLoad() {
    const { categoryId = '' } = this.productCategorySelect || {}
    const { ID = '' } = this.productDistrictSelect || {}
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestProduct, start: this.start, position: this.location, level4CategoryId: categoryId, districtId: ID, distanceSort: this.productDistanceSort, saleNumSort: this.productSalesSort, defaultSort: this.productDefaultSort })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.cmmdtyInfo) {
        const { total, list: newData = [] } = data.cmmdtyInfo
        this.setProductNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetProduct()
    this.refresh()
  }
}
